import { ONE } from 'config/apis'

const getMatchesCategories = async (id) => {
  try {
    const req = await fetch(
      ONE.TOR_DRAWS_FILTERS.replace('{id}', id),
      ONE.HEADERS
    )
    const parsed = await req.json()
    return parsed?.Data || parsed
  } catch (err) {
    console.log(err)
  }
}

const getTorsReq = async ({
  year = new Date().getFullYear(),
  category = '',
  delegation = '',
  page = 1,
  limit = 4
}) => {
  try {
    const reqTors = await fetch(
      `${ONE.TOR_LIST}?year=${year}&category=${category}&delegation=${delegation}&page=${page}&limit=${limit}`,
      ONE.HEADERS
    )
    const tors = await reqTors.json()
    return tors.Data
  } catch (error) {}
}

export { getMatchesCategories, getTorsReq }
